import {
  sendGoogleEvent,
  sendRequest,
} from '@html/_common/utils';

import copyTextToClipboard from '@html/_utils/copy-text-to-clipboard';
import SliderPopup from '@scout/components/slider-popup/slider-popup';

const isMobileDevice = $(window).width() <= 768;

export default class AOTourTravelAgentShareTour {
  constructor({ tourId, serpId }) {
    this.eventCategory = 'TDP (Travel Agent) share tour';
    this.eventLabel = 'Travel Agent';
    this.TEMPLATE_ENDPOINT = '/api/popup/travel-agent';

    this.sliderPopup = null;

    this.selectors = {
      overlay: '.js-ao-common-travel-agent-share-tour__overlay',
      modal: '.js-ao-common-travel-agent-share-tour',
      close: '.js-ao-common-travel-agent-share-tour__close, .js-ao-common-travel-agent-share-tour__cancel',
      copyTrigger: '.js-ao-common-travel-agent-share-tour__copy-trigger',
      contentToCopy: '.js-ao-common-travel-agent-share-tour__copy-content',
      successText: '.js-ao-common-travel-agent-popup__success-text',
      sliderPopupWrapper: '.js-ao-common-travel-agent-popup__slider-popup-wrapper',
    };

    this.tourId = tourId;
    this.serpId = serpId;
    this.loading = false;
  }

  static getTriggerSelector() {
    return '.js-ao-common-travel-agent-share-tour__trigger';
  }

  init() {
    this.loadPopup({
      successCallback: () => {
        $(document).on(
          'click',
          AOTourTravelAgentShareTour.getTriggerSelector(),
          (event) => {
            event.preventDefault();
            if (this.loading || !$(this.selectors.overlay).length) {
              return;
            }
            this.open();
          },
        );

        if (isMobileDevice) {
          this.sliderPopup = new SliderPopup({
            wrapper: this.selectors.sliderPopupWrapper,
            onClose: () => {},
          });
          this.sliderPopup.initialize();
        }
      },
      errorCallback: () => {
        $(AOTourTravelAgentShareTour.getTriggerSelector()).remove();
      },
    });

    $(document).on('click', this.selectors.close, () => {
      this.close();
    });

    if (this.tourId) {
      this.appendSharingUriParam();
    }
  }

  attachCopyEvent() {
    if (!this.copyEventAttached) {
      $(document).on('click', this.selectors.copyTrigger, () => {
        let contentElement;
        if (isMobileDevice) {
          contentElement = $(this.selectors.sliderPopupWrapper).find(this.selectors.contentToCopy);
        } else {
          contentElement = $(this.selectors.modal).find(this.selectors.contentToCopy);
        }

        copyTextToClipboard(
          contentElement.text().trim(),
          () => {
            this.showSuccessToast();
          },
        );
      });
      this.copyEventAttached = true;
    }
  }

  open() {
    if (isMobileDevice) {
      this.sliderPopup.openDialog();
    } else {
      $(this.selectors.overlay)
        .removeClass('hid');
    }

    this.attachCopyEvent();

    sendGoogleEvent(
      this.eventCategory,
      'Click the “Share tour” button',
      this.eventLabel,
      { ampEventName: 'ta_tdp_share_form_opened' },
    );
  }

  close() {
    if (isMobileDevice) {
      this.sliderPopup.hideDialog();
    } else {
      $(this.selectors.overlay).addClass('hid');
    }
    sendGoogleEvent(
      this.eventCategory,
      'Click the Cancel button',
      this.eventLabel,
    );
  }

  loadPopup({ successCallback, errorCallback }) {
    this.loading = true;
    sendRequest(this.TEMPLATE_ENDPOINT, {
      action: this.tourId ? 'shareTour' : 'shareSerp',
      tourId: this.tourId,
      serpId: this.serpId,
    }, (data) => {
      if (data.status === 'OK') {
        $('main').append(data.component);
        successCallback();
      } else {
        errorCallback();
      }
      this.loading = false;
    }, { dataType: 'json', type: 'POST' }, errorCallback);
  }

  appendSharingUriParam() {
    sendRequest(this.TEMPLATE_ENDPOINT, {
      action: 'coBrandingParam',
      tourId: this.tourId,
    }, (data) => {
      if (data.status === 'OK') {
        window.history.replaceState({}, '', `?${data.uriParam}`);
      }
    });
  }

  showSuccessToast() {
    if ($('.js-share-tour-confirmation').length) {
      return;
    }

    const successText = $(this.selectors.successText).data('success');

    $(this.selectors.successText).append(
      $('<div>', {
        class: 'js-share-tour-confirmation ao-common-travel-agent-popup__toast ao-common-travel-agent-popup__toast-icon ao-common-travel-agent-popup__toast-icon--success',
        text: successText,
      }),
    );

    setTimeout(() => {
      $(this.selectors.successText).children().remove();
    }, 4000);

    sendGoogleEvent(
      this.eventCategory,
      'Click the “Copy link“ CTA',
      this.eventLabel,
      { ampEventName: 'ta_tdp_share_form_link_copied' },
    );
  }
}
